import { EventBus, Analytics } from './index'

const ACTIVITY_OPEN = 'activity-open'

export default {
    ACTIVITY_OPEN,
    open(url, title, projectIndex, routePath, routeName) {
        EventBus.$emit(ACTIVITY_OPEN, url)
        Analytics.sendActivityEvent(title, projectIndex, routePath, routeName)
    }
}